import { FILE_TYPES } from '@/constants';
import { invoicesAPI, filesAPI } from '../services/api';

const generateInvoiceFileName = (invoiceNumber: string) => `invoice-${invoiceNumber}.pdf`;

export const generateAndUploadInvoicePDF = async (invoiceId: string, invoiceNumber: string) => {
  try {
    // Generate PDF using the API service
    const pdfResponse = await invoicesAPI.generatePDFBlob(invoiceId);
    
    const fileName = generateInvoiceFileName(invoiceNumber);
    
    // Create download link for PDF
    const url = window.URL.createObjectURL(new Blob([pdfResponse]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    // Upload the generated PDF as a file using the API service
    const pdfBlob = new Blob([pdfResponse], { type: FILE_TYPES.PDF });
    const pdfFile = new File([pdfBlob], fileName, { type: FILE_TYPES.PDF });
    
    await filesAPI.upload(pdfFile, 'INVOICE', invoiceId, fileName);
 
    return true;
  } catch (error: any) {
    console.error('PDF generation or upload failed:', error);
    return false;
  }
};
